(function () {
  const CHIP_SELECTOR = '.javazap-collection-filter-chip';
  const SUMMARY_SELECTOR = '.javazap-collection-filter-chip__button';
  const PANEL_SELECTOR = '.javazap-collection-filter-chip__panel';
  const COUNT_SELECTOR = '.javazap-collection-filter-chip__count';

  function closeOtherChips(active) {
    document.querySelectorAll(CHIP_SELECTOR + '[open]').forEach((chip) => {
      if (chip !== active) chip.open = false;
    });
  }

  document.addEventListener('toggle', (event) => {
    const chip = event.target;
    if (!(chip instanceof HTMLElement) || !chip.matches(CHIP_SELECTOR)) return;
    if (chip.open) closeOtherChips(chip);
  }, true);

  document.addEventListener('click', (event) => {
    const openChips = document.querySelectorAll(CHIP_SELECTOR + '[open]');
    if (!openChips.length) return;
    openChips.forEach((chip) => {
      if (!chip.contains(event.target)) chip.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(CHIP_SELECTOR + '[open]').forEach((chip) => {
      chip.open = false;
      chip.querySelector('summary')?.focus();
    });
  });

  // After AJAX filter update, refresh chip summary (badge count) and panel (active states)
  // by pulling fresh markup from the section response.
  function subscribeToFacetUpdates() {
    if (!window.theme || !theme.pubsub || !theme.pubsub.PUB_SUB_EVENTS) {
      return false;
    }
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, onFacetUpdate);
    return true;
  }

  function onFacetUpdate(event) {
    if (!event || !event.responseText) return;
    const parsed = new DOMParser().parseFromString(event.responseText, 'text/html');
    const incoming = parsed.querySelectorAll(CHIP_SELECTOR);
    const current = document.querySelectorAll(CHIP_SELECTOR);
    if (!current.length) return;

    incoming.forEach((nc, i) => {
      const cc = current[i];
      if (!cc) return;
      const wasOpen = cc.open;

      const newSummary = nc.querySelector(SUMMARY_SELECTOR);
      const newPanel = nc.querySelector(PANEL_SELECTOR);
      const curSummary = cc.querySelector(SUMMARY_SELECTOR);
      const curPanel = cc.querySelector(PANEL_SELECTOR);

      if (newSummary && curSummary) curSummary.innerHTML = newSummary.innerHTML;
      if (newPanel && curPanel) curPanel.innerHTML = newPanel.innerHTML;

      cc.open = wasOpen;
    });
  }

  if (!subscribeToFacetUpdates()) {
    document.addEventListener('DOMContentLoaded', subscribeToFacetUpdates);
  }
})();
